// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"343":"33c888f3","379":"33c888f3","413":"33c888f3","457":"bddef647","716":"33c888f3","735":"33c888f3","828":"33c888f3"}[chunkId] + ".chunk.css";
};